// Full-year date range for the "Year" quick-filter (Jan 1 – Dec 31).
export function yearDateRange(year) {
  return { from: `${year}-01-01`, to: `${year}-12-31` };
}

// Dashboard/Brief Report/Month-wise Analysis all default to the current calendar year
// so they open on relevant recent data instead of an all-time total, and "Clear filters"
// returns to this same current-year view rather than to a blank "All years" state.
export function getDefaultDashboardFilters() {
  const currentYear = new Date().getFullYear();
  return {
    ...yearDateRange(currentYear),
    customerCode: '',
    salesmanCode: '',
    productCode: '',
    category: '',
    channel: '',
    subChannel: '',
  };
}

// Detects whether a filters object's from/to exactly spans one full calendar year,
// so the Year dropdown can reflect the current selection instead of always showing blank.
export function detectSelectedYear(filters) {
  if (!filters.from || !filters.to) return '';
  const match = filters.from.match(/^(\d{4})-01-01$/);
  if (!match) return '';
  return filters.to === `${match[1]}-12-31` ? match[1] : '';
}
